import { combineReducers } from 'redux';
import channel, { initialState as channelState } from './modules/ModulesReducerChannel';
import live, { initialState as liveState } from './modules/ModulesReducerLive';
import evaluation, { initialState as evaluationState } from './modules/ModulesReducerEvaluation';
import topic, { initialState as topicState } from './modules/ModulesReducerTopic';
import common, { initialState as commonState } from './modules/ModulesReducerCommon';

/**
 * 注册state
 */
export const initialState: any = {
	channel: channelState,
	live: liveState,
	evaluation: evaluationState,
	topic: topicState,
	common: commonState,
};

/**
 * 合并
 */
export default combineReducers({
	channel,
	live,
	evaluation,
	topic,
	common,
});
